var _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 133,
    viewBox: "0 0 203 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 165.941,
    y2: -1.5,
    transform: "matrix(0.876075 0.482174 -0.0132806 0.999912 0 52.7236)",
    stroke: "#C0C2C3",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 165.941,
    y2: -1.5,
    transform: "matrix(0.876075 0.482174 -0.0132806 0.999912 28.3596 27.8618)",
    stroke: "#C0C2C3",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 165.941,
    y2: -1.5,
    transform: "matrix(0.876075 0.482174 -0.0132806 0.999912 56.7192 3)",
    stroke: "#C0C2C3",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.53dd548f74ba7b6f8212f0837bb9d923.svg";
export { ForwardRef as ReactComponent };